export interface CustomerAddressEdit {
  id: string;
  customerId: string;
  addressId: string;
}
